import React from 'react';
import { Tabs, TabItem } from '@naf-simba/sections-tabs';

type Props = {
  /** One entry per test group, in strip order. */
  items: TabItem[];
  /** The selected group. Undefined until the first group resolves. */
  selectedTab?: { key: string; value: string };
  onSelectTab: (key: string) => void;
  /**
   * Render every panel, not just the active one. Only worth it where a panel holds something
   * expensive to rebuild on each switch — and note it multiplies whatever the panels contain.
   */
  keepMounted?: boolean;
};

/**
 * A single test needs no strip, so its panel is rendered on its own — the
 * behaviour the legacy markup got from gating `TabList` on `testContexts.length > 1`.
 */
export const TestTabs: React.FC<Props> = ({ items, selectedTab, onSelectTab, keepMounted }) => {
  if (items.length <= 1) {
    return items[0]?.content ?? null;
  }

  return <Tabs items={items} value={selectedTab?.key} onChange={onSelectTab} keepMounted={keepMounted} />;
};
